/* unplugin-vue-components disabled */import script from "./CompetitionList.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionList.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionList.vue?vue&type=style&index=0&id=53628bd4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53628bd4"]])

export default __exports__